import { Injectable } from '@angular/core';
import { Route } from '@angular/router';

import { ClientConfigProductName, RouteProcessor } from '@frontend/vanilla/core';

@Injectable()
export class SportsRouteProductProcessor implements RouteProcessor {
    // eslint-disable-next-line @typescript-eslint/class-methods-use-this
    process(
        route: Route & {
            data: {
                product: string | undefined;
            };
        },
    ): Route | null {
        const routeProduct = route.data?.product || ClientConfigProductName.SPORTS;

        route.data = {
            ...route.data,
            product: routeProduct,
        };

        return route;
    }
}
